import React from "react";
import SocialLink from "./SocialLink";

const SocialsLinks = ({items}) => {

  return items && (
    <div className="d-flex gap-32">
      {items?.linkedin && (
        <SocialLink url={items.linkedin} name="LinkedIn">
          <svg width="20" height="18"><use xlinkHref="#icon-social-network-linkedin"></use></svg>
        </SocialLink>
      )}
      {items?.facebook && (
        <SocialLink url={items.facebook} name="Facebook">
          <svg width="11" height="18"><use xlinkHref="#icon-social-network-facebook"></use></svg>
        </SocialLink>
      )}
      {items?.instagram && (
        <SocialLink url={items.instagram} name="Instagram">
          <svg width="21" height="20"><use xlinkHref="#icon-social-network-instagram"></use></svg>
        </SocialLink>
      )}
      {items?.youtube && (
        <SocialLink url={items.youtube} name="YouTube">
          <svg width="22" height="16"><use xlinkHref="#icon-social-network-youtube"></use></svg>
        </SocialLink>
      )}
    </div>
  )
}

export default SocialsLinks
